import { render, staticRenderFns } from "./classManage.vue?vue&type=template&id=20a7ebf7&scoped=true&"
import script from "./classManage.vue?vue&type=script&lang=js&"
export * from "./classManage.vue?vue&type=script&lang=js&"
import style0 from "./classManage.vue?vue&type=style&index=0&id=20a7ebf7&scoped=true&lang=scss&"
import style1 from "./classManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7ebf7",
  null
  
)

export default component.exports